import axios from 'axios'

export default {
  install(Vue: any, options: any) {
    Vue.$optimoRoute = Vue.prototype.$optimoRoute = {
      apiKey: options.apiKey,
      url: 'https://api.optimoroute.com/v1',

      async createRequestObject(method: string, url: string, data: any) {
        const settings = { mode: 'cors', method: '', url: '' }
        settings.method = method
        settings.url = url
        if (settings.method === 'POST') {
          // @ts-ignore
          settings.data = JSON.stringify(data)
        }
        const instance = axios.create()
        delete instance.defaults.headers.common.Authorization
        try {
          // @ts-ignore
          return await instance(settings)
            .then(resp => {
              return resp.data
            })
            .catch(err => console.log(err))
        } catch (error) {}
      },

      getDefaultUrl(command: string) {
        let url = this.url
        url += '/' + command
        url += '?key=' + encodeURIComponent(this.apiKey)
        return url
      },

      deleteOrder(orderNo: string) {
        const url = this.getDefaultUrl('delete_order')
        return this.createRequestObject('POST', url, { orderNo: orderNo })
      },

      deleteOrders(orders: Array<any>) {
        const url = this.getDefaultUrl('delete_orders')
        return this.createRequestObject('POST', url, { orders: orders })
      },

      deleteAllOrdersBy(date: string) {
        const url = this.getDefaultUrl('delete_all_orders')
        return this.createRequestObject('POST', url, { date: date })
      },

      createOrder(order: {}) {
        const url = this.getDefaultUrl('create_order')
        return this.createRequestObject('POST', url, order)
      },

      createUpdateOrders(orders: {}) {
        const url = this.getDefaultUrl('create_or_update_orders')
        return this.createRequestObject('POST', url, { orders: orders })
      },

      startPlanning(date: string) {
        const url = this.getDefaultUrl('start_planning')
        return this.createRequestObject('POST', url, { date: date })
      },

      startPlanningByDateRange(daterange: {}) {
        const url = this.getDefaultUrl('start_planning')
        const payload = {
          dateRange: daterange,
          balancing: 'OFF',
          depotTrips: true,
          depotVisitDuration: 30,
          clustering: true,
        }
        return this.createRequestObject('POST', url, payload)
      },

      stopPlanning(planningId: number) {
        const url = this.getDefaultUrl('stop_planning')
        return this.createRequestObject('POST', url, { planningId: planningId })
      },

      getRoute(date: string) {
        let url = this.getDefaultUrl('get_routes')
        url += '&date=' + date
        return this.createRequestObject('GET', url)
      },

      getOrders(orders: {}) {
        const url = this.getDefaultUrl('get_orders')
        return this.createRequestObject('POST', url, orders)
      },

      getSchedulingInformation(orderNo: string) {
        let url = this.getDefaultUrl('get_scheduling_info')
        url += '&orderNo=' + orderNo
        return this.createRequestObject('GET', url)
      },

      getPlanningStatus(planningId: number) {
        let url = this.getDefaultUrl('get_planning_status')
        url += '&planningId=' + planningId
        return this.createRequestObject('GET', url)
      },
    }
  },
}
